<div *ngIf="term" [style.margin]="padding ? '20px' : '0'" (click)="seeMore()">
  <p class="button-text" [style.text-align]="align">
    More "<span style="font-weight: bold">{{ term | uppercase }}</span
    >" plates
  </p>
</div>
